import { render, staticRenderFns } from "./ShipmentRequest.vue?vue&type=template&id=15021ea4"
import script from "./ShipmentRequest.vue?vue&type=script&lang=js"
export * from "./ShipmentRequest.vue?vue&type=script&lang=js"
import style0 from "./ShipmentRequest.vue?vue&type=style&index=0&id=15021ea4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports